module.exports = __webpack_public_path__ + "../assets/img/aebc9a77ab6b323b28ad58c6c5d08efa.svg";